/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import React from 'react'
import { SettingsManager } from '../../configuration/SettingsManager'
import { ModalHeader, ModalBody, Button, ModalFooter, Alert, Modal } from 'reactstrap'
import { IUserSessionStateManager } from '../../services/UserSessionStateManager/contracts'
import { container } from '../../configuration/ServiceLocator'
import './UserSession.scss'

export interface IUserSessionState {
	isSessionExpirationModalVisible: boolean
	isSessionExpiredModalVisible: boolean
	sessionExpirationCountdown: string
}

export interface IUserSessionProps {
	userSessionStore: IUserSessionStateManager
}

export class UserSession extends React.Component<IUserSessionProps, IUserSessionState> {
	constructor (props: IUserSessionProps) {
		super(props)
		this.state = {
			isSessionExpirationModalVisible: false,
			isSessionExpiredModalVisible: false,
			sessionExpirationCountdown: '',
		}

		this.props.userSessionStore.loadSessionJwt(false)
		const _this = this
		// every second check the token's expiry and determine if warning/error dialogs should be displayed
		setInterval(function () {
			const totalSecondsUntilExpiration = (_this.props.userSessionStore.userSession.exp.getTime() - new Date().getTime()) / 1000
			const totalSecondsUntilWarningPopup = totalSecondsUntilExpiration - SettingsManager.REACT_APP_SECONDS_BEFORE_EXPIRATION_WARNING().value
			const minutes = Math.floor(totalSecondsUntilExpiration / 60)
			const seconds = Math.floor(totalSecondsUntilExpiration % 60)

			const padLeft = (num: number, length: number): string => {
				return Array(Math.max(String(num).length, length) - String(num).length + 1).join('0') + num
			}
			_this.setState({
				isSessionExpirationModalVisible: totalSecondsUntilExpiration > 0 && totalSecondsUntilWarningPopup < 0,
				isSessionExpiredModalVisible: totalSecondsUntilExpiration < 0 && _this.props.userSessionStore.userSession.exp.getTime() > 0,
				sessionExpirationCountdown: `${padLeft(minutes, 2)}:${padLeft(seconds, 2)}`,
			})
			if (_this.state.isSessionExpiredModalVisible == true) {
				_this.Logout()
			}

		}, 1000)
	}

	Logout(): void {
		localStorage.removeItem(SettingsManager.REACT_APP_SSO_TOKEN_NAME)
		localStorage.removeItem(SettingsManager.REACT_APP_Refresh_TOKEN_NAME)
		localStorage.removeItem(SettingsManager.REACT_APP_ProductCategories_TOKEN_NAME)
		window.location.href = '/Auth/Logout'
	}

	onTokenRefresh(event: any): void {
		event.preventDefault()
		this.props.userSessionStore.loadSessionJwt(true).catch(error => alert(error))
	}

	render() {
		return (
			<div>
				<Modal isOpen={this.state.isSessionExpirationModalVisible}>
					<ModalHeader>Session Timeout Warning</ModalHeader>
					<ModalBody>
						<p className="ui-icon ui-icon-alert">Your session is about to expire in {this.state.sessionExpirationCountdown} seconds.</p>
						<p>Click OK to Continue your session</p>
					</ModalBody>
					<ModalFooter>
						<Button className="session-continue" id="btnSessionContinue" onClick={e => this.onTokenRefresh(e)}>
							OK
						</Button>
					</ModalFooter>
				</Modal>
			</div>

		)
	}
}

export const UserSessionConnected = () => {
	const store = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	return <UserSession userSessionStore={store} />
}